/**
 * Sky High custom age gate — 21+, cookie-based.
 * Triggers on product pages and product link / quick-add interactions.
 */
(function () {
  'use strict';

  var root = document.getElementById('SkyHighAgeGate');
  if (!root) return;

  var COOKIE = root.getAttribute('data-cookie') || 'skyhigh_age_ok';
  var DAYS = parseInt(root.getAttribute('data-days') || '30', 10) || 30;
  var EXIT = root.getAttribute('data-exit-url') || 'https://www.google.com';
  var pendingHref = null;
  var open = false;

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      maxAge +
      '; SameSite=Lax' +
      secure;
  }

  function isVerified() {
    return getCookie(COOKIE) === '1';
  }

  function isProductPage() {
    return (
      document.body.classList.contains('template-product') ||
      /^\/products\//.test(location.pathname)
    );
  }

  function isProductHref(href) {
    if (!href) return false;
    try {
      var u = new URL(href, location.origin);
      if (u.origin !== location.origin) return false;
      return /\/products\//.test(u.pathname);
    } catch (e) {
      return false;
    }
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('sky-age-gate-open', on);
    document.body.classList.toggle('sky-age-gate-open', on);
  }

  function show(nextHref) {
    if (isVerified()) {
      if (nextHref) location.href = nextHref;
      return;
    }
    pendingHref = nextHref || null;
    open = true;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    // reflow for transition
    void root.offsetWidth;
    root.classList.add('sky-age-gate--in');
    lockScroll(true);
    var yes = root.querySelector('[data-age-gate-yes]');
    if (yes) {
      try {
        yes.focus();
      } catch (e) {}
    }
  }

  function hide() {
    open = false;
    root.classList.remove('sky-age-gate--in');
    root.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    setTimeout(function () {
      if (!open) root.hidden = true;
    }, 320);
  }

  function accept() {
    setCookie(COOKIE, '1', DAYS);
    hide();
    if (pendingHref) {
      var href = pendingHref;
      pendingHref = null;
      location.href = href;
    }
  }

  function decline() {
    pendingHref = null;
    hide();
    location.href = EXIT;
  }

  var yesBtn = root.querySelector('[data-age-gate-yes]');
  var noBtn = root.querySelector('[data-age-gate-no]');
  if (yesBtn) yesBtn.addEventListener('click', accept);
  if (noBtn) noBtn.addEventListener('click', decline);

  // Product page: gate immediately if not verified
  if (isProductPage() && !isVerified()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        show(null);
      });
    } else {
      show(null);
    }
  }

  // Intercept product navigation sitewide
  document.addEventListener(
    'click',
    function (e) {
      if (isVerified() || open) return;
      var t = e.target;
      if (!t || !t.closest) return;

      // Product links
      var a = t.closest('a[href]');
      if (a && isProductHref(a.getAttribute('href'))) {
        // allow modified clicks (new tab)
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
        e.preventDefault();
        e.stopPropagation();
        show(a.href);
        return;
      }

      // Quick-add / product forms that open product flow without full nav
      var quick = t.closest(
        'product-form button[type="submit"], .quick-add__submit, button.quick-add__submit, [name="add"]'
      );
      if (quick && (isProductPage() || t.closest('.card-wrapper, .product-card-wrapper, product-card'))) {
        // On collection cards quick-add — require age first
        if (!isProductPage()) {
          e.preventDefault();
          e.stopPropagation();
          show(null);
        }
      }
    },
    true
  );

  // Escape does not bypass — must choose Yes/No
  document.addEventListener('keydown', function (e) {
    if (!open) return;
    if (e.key === 'Escape') {
      e.preventDefault();
    }
  });
})();
